import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import { Loading } from './Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoleUtils from '../utils/roleUtils.js';
import '../styles/Home.css';


class HomeActionCard extends React.Component {
    buildActionCard() {
        const { currentUser, cardIcon, cardLink, cardTitle, cardDescription, cardPermissions, currentCompanyId, idx } = this.props;
        if (currentUser && currentUser.suppliers) {
            var canView = RoleUtils.canAccess(currentUser, currentCompanyId, cardPermissions)
            if (cardLink === "/Inbox") {
                return (
                    <Col md={3} key={idx} className="homeCardArea">
                        <Card className="homeNavCard border-left-dark shadow borderCurve">
                            <Card.Body>
                                <a href={cardLink}>
                                    <div className="navIcon">
                                        <FontAwesomeIcon size="4x" icon={cardIcon} />
                                    </div>
                                    <Card.Title className="center">{cardTitle}</Card.Title>
                                </a>
                                <Card.Text className="center">
                                    {cardDescription}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>);
            }
            else if (canView) {
                return (
                    <Col md={3} key={idx} className="homeCardArea">
                        <Card className="homeNavCard border-left-dark shadow borderCurve">
                            <Card.Body>
                                <Link to={cardLink}>
                                    <div className="navIcon">
                                        <FontAwesomeIcon size="4x" icon={cardIcon} />
                                    </div>
                                    <Card.Title className="center">{cardTitle}</Card.Title>
                                </Link>
                                <Card.Text className="center">
                                    {cardDescription}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>);
            }
        }
    }

    render() {
        const { currentUser } = this.props;
        const display = (currentUser) ? this.buildActionCard() : <div className="emptyActionCard"><Loading /></div>;
        return (
            <>
                {display}
            </>
        );
    }
}

export default HomeActionCard




